<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>APPRENDISTATO</li>
            </ul>
            <h2>Piani Formativi per Apprendistato</h2>
        </div>
    </div>
    <div class="shape9 d-none"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="courses-details-area pb-100">
    <div class="courses-details-image d-none">
        <img src="assets/img/pargol.jpg" style="max-height:496px; width:100%; object-fit: cover;  object-position: bottom bottom;" alt="image">
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="courses-details-desc">
                    <ngx-tabset>
                        <ngx-tab tabTitle="">
                            <div class="courses-overview">
                                <h3>Benvenuto nella nostra piattaforma FAD – Sezione Apprendistato</h3>
                                <p>
                                    In questa sezione troverai tutti i corsi online attivi dedicati alla <b>formazione obbligatoria per apprendisti</b>, in particolare relativa al contratto di apprendistato professionalizzante.
                                </p>
                                <p>
<b>L’apprendistato professionalizzante</b> è un contratto a tempo indeterminato rivolto ai giovani tra i 18 e i 29 anni (o dai 17 anni per chi ha assolto l’obbligo scolastico), che unisce lavoro e formazione.
Ai sensi del D.Lgs. 81/2015 e delle disposizioni regionali vigenti, i datori di lavoro sono tenuti a garantire all’apprendista un percorso formativo finalizzato all’acquisizione di <b>competenze di base e trasversali</b>, da svolgere presso un ente di formazione accreditato.
                                </p>
                                <p>
                                La nostra piattaforma è progettata per offrire un’esperienza formativa semplice, flessibile e conforme agli standard regionali, permettendo ai giovani apprendisti di acquisire le competenze di base e trasversali richieste dalla normativa, anche a distanza.
                                </p>

                                    <h3 class="pt-3">📘 I percorsi formativi previsti:</h3>
                                <p>
<b>Il periodo dell’obbligo formativo varia in funzione del titolo di studio posseduto dall’apprendista</b> al momento dell’assunzione.
                                </p>
                                <p>
In particolare il piano formativo comprende sia ore teoriche, da svolgersi seguendo i corsi in elenco, che ore on the job, in azienda, sotto la supervisione di un tutor aziendale ed ha una durata complessiva di
                                </p>
                                <ul>
                                <li>📎 <b>120 ore</b> per apprendisti con <b>licenza media o senza titolo di studio</b></li>
                                <li>📎 <b>80 ore</b> per apprendisti con <b>qualifica professionale, diploma o qualifica IeFP</b></li>
                                <li>📎 <b>40 ore</b> per apprendisti con <b>laurea o titolo equivalente</b></li>
                                </ul>
                                <p>Tutti i corsi sono:</p>
                                    <ul>
                                        <li>✅ Disponibili online 24 ore su 24</li>
                                        <li>✅ Fruibili da qualsiasi dispositivo</li>
                                        <li>✅ Tracciati per garantire il rispetto degli obblighi formativi</li>
                                        <li>✅ Conclusi con test finale e rilascio dell’attestazione</li>
                                    </ul>
                                   <h3 class="pt-3">
                                    📚 Seleziona qui sotto il tuo corso e inizia la formazione
                                   </h3>
                                   <a href="/elenco-corsi/apprendistato-1-anno" class="default-btn mt-3 me-3 ms-5" style="padding-left: 15px; padding-right: 15px; background-color:var(--mainColor); cursor: pointer;">
                                        Corsi del 1° Anno
                                   </a>
                                    <a href="/elenco-corsi/apprendistato-2-anno" class="default-btn mt-3 me-3" style="padding-left: 15px; padding-right: 15px; background-color:var(--mainColor); cursor: pointer;">
                                        Corsi del 2° Anno
                                    </a>
                                    <a href="/elenco-corsi/apprendistato-3-anno" class="default-btn mt-3" style="padding-left: 15px; padding-right: 15px; background-color:var(--mainColor); cursor: pointer;">
                                        Corsi del 3° Anno
                                    </a>
                                </div>


                            <div class="btn-box mt-5 d-none">
                                <a routerLink="/contatti" class="default-btn"><i class="flaticon-tag"></i>Richiedi informazioni<span></span></a>
                            </div>
                        </ngx-tab>
                    </ngx-tabset>
                </div>
            </div>
            <div class="col-lg-4 col-md-12 d-none">
                <div class="courses-details-info">
                    <div class="image">
                        <img src="assets/img/courses/img1.jpg" alt="image">
                        <a href="https://www.youtube.com/watch?v=PWvPbGWVRrU" class="link-btn popup-youtube"></a>
                        <div class="content">
                            <i class="flaticon-play"></i>
                            <span>Course Preview</span>
                        </div>
                    </div>
                    <ul class="info">
                        <li class="price">
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-tag"></i> Price</span>
                                $49
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-teacher"></i> Instructor</span>
                                Sarah Taylor
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-time"></i> Duration</span>
                                7 weeks
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-distance-learning"></i> Lessons</span>
                                25
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-web"></i> Enrolled</span>
                                255 students
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-lock"></i> Access</span>
                                Lifetime
                            </div>
                        </li>
                    </ul>
                    <div class="btn-box">
                        <a routerLink="/contatti" class="default-btn"><i class="flaticon-tag"></i>Richiedi informazioni<span></span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="courses-area bg-f8f9f8 pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Altri corsi che potrebbero piacerti</h2>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6" *ngFor="let propostaCorso of nPropostaCorsi">
                <div class="single-courses-box">
                    <div class="courses-image">
                        <a target="_parent" href="/dettaglio-corso/{{propostaCorso['corso']['tag']}}" class="d-block image">
                            <img *ngIf="propostaCorso['corso']['isMiur']==1" src="assets/img/miur.png" style="height: 50px; position: absolute; bottom: 20px; left: 25px;">
                            <img src="{{urlImage+propostaCorso['corso']['image']}}" alt="image">
                        </a>
                    </div>
                    <div class="courses-content">
                        <h3><a target="_parent" href="/dettaglio-corso/{{propostaCorso['corso']['tag']}}">{{propostaCorso['corso']['titolo']}}</a></h3>
                        <p style="overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  -webkit-line-clamp: 3;
                                  -webkit-box-orient: vertical">{{propostaCorso['corso']['descrizione']}}</p>
                        <ul *ngIf="propostaCorso['corso']['durata'].durata_numero>0" class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li class="fw-bold"><i class='flaticon-time-left'></i>
                                {{propostaCorso['corso']['durata'].durata_numero}}{{propostaCorso['corso']['durata'].durata_label}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

